<div class="min-vh-100 bg-light">
  <app-header [page]="'Wallets'"></app-header>

  <main class="container py-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="mb-0 fw-bold">Saved Beneficiaries</h4>
        <div class="text-muted small">Manage beneficiaries for this wallet only</div>
      </div>

      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="back()">
        Back to Withdrawal
      </button>
    </div>

    <div class="card shadow-sm border-0" *ngIf="loading">
      <div class="card-body text-center py-4">
        <span class="spinner-border spinner-border-sm me-2"></span>
        Loading beneficiaries...
      </div>
    </div>

    <div *ngIf="!loading && !items.length" class="card shadow-sm border-0">
      <div class="card-body py-4 text-center">
        <h6 class="fw-bold mb-1">No beneficiaries yet</h6>
        <div class="text-muted small mb-3">
          Saved beneficiaries for this wallet will appear here after a withdrawal is saved as beneficiary.
        </div>

        <button class="btn btn-primary btn-sm" type="button" (click)="back()">
          Go to Withdrawal
        </button>
      </div>
    </div>

    <div class="row g-3" *ngIf="!loading && items.length">
      <div class="col-12" *ngFor="let item of items">
        <div class="card shadow-sm border-0">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap mb-3">
              <div>
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <h6 class="mb-0 fw-bold">
                    {{ item.nickname || 'Beneficiary' }}
                  </h6>
                  <span class="badge rounded-pill" [ngClass]="badgeClass(item.isActive)">
                    {{ item.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </div>

                <div class="text-muted small mt-1">
                  {{ item.paymentMethod || 'N/A' }} • Created {{ item.createdAt | date:'medium' }}
                </div>
              </div>

              <div class="d-flex gap-2">
                <button
                  class="btn btn-outline-primary btn-sm"
                  type="button"
                  (click)="useBeneficiary(item)"
                  [disabled]="!item.isActive">
                  Use + Continue
                </button>

                <button
                  class="btn btn-outline-warning btn-sm"
                  type="button"
                  (click)="toggleStatus(item)"
                  [disabled]="togglingId === item.id">
                  <span *ngIf="togglingId === item.id" class="spinner-border spinner-border-sm me-2"></span>
                  {{ item.isActive ? 'Deactivate' : 'Reactivate' }}
                </button>
              </div>
            </div>

            <div class="row g-3">
              <div class="col-md-6" *ngFor="let entry of destinationEntries(item.destinationDetailsJson)">
                <div class="text-muted small">{{ entry.label }}</div>
                <div class="fw-semibold">{{ entry.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </main>
</div>